import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import OptionTitle from '../../option-title';

import './style.scss';

export default class Option extends Component {
  optionClassName() {
    return classnames('uni-select__option', {
      'uni-select__option--is-selected': this.props.isSelected,
      'uni-select__option--is-hovered': this.props.isHighlighted,
    });
  }

  matchLabel(label) {
    const { matchData, matchHead } = this.props;
    if (!matchData) return label;

    const re = new RegExp(`(${matchData})`, 'gi');

    let matches = label.split(re);

    // Nothing matched
    if (matches.length === 1) return label;

    if (matchHead) {
      // If we are matching on head, the label will be a filtered result,
      // that means the first item in the matches array (index 0) is an empty
      // string, we might as well cut that out and use the second item, which
      // is the matched text, while the rest of the array is unmatched data.
      matches = [matches[1], matches.slice(2).join('')];
    }

    return matches.map((part, index) => {
      return (
        <span
          key={part + index}
          className={part.toLowerCase() === matchData.toLowerCase() ? 'uni-select__option--is-matching' : undefined}
        >
          {part}
        </span>
      );
    });
  }

  render() {
    const { isHighlighted, isSelected, optionData, children, qaId, matchData, matchHead, ...itemProps } = this.props;

    const itemClass = classnames('uni-select__item', {
      ['uni-select__item--disabled']: optionData.disabled,
    });

    return (
      <li
        {...itemProps}
        className={itemClass}
        role="presentation"
        data-qa-id={qaId}
        aria-disabled={optionData.disabled}
      >
        <div className={this.optionClassName()} role="option">
          {children ? (
            children({ isHighlighted, isSelected, optionData, matchData, matchHead, ...itemProps })
          ) : (
            <div className="uni-select__content">
              <OptionTitle>{this.matchLabel(optionData.label)}</OptionTitle>
            </div>
          )}
        </div>
      </li>
    );
  }
}

Option.propTypes = {
  isHighlighted: PropTypes.bool,
  isSelected: PropTypes.bool,
  children: PropTypes.func,
  qaId: PropTypes.string,
  optionData: PropTypes.object,
  matchData: PropTypes.string,
  matchHead: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/selects/__partials/option/index.jsx